import { render, staticRenderFns } from "./create-form.vue?vue&type=template&id=e563ff48&scoped=true&"
import script from "./create-form.vue?vue&type=script&lang=js&"
export * from "./create-form.vue?vue&type=script&lang=js&"
import style0 from "./create-form.vue?vue&type=style&index=0&id=e563ff48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e563ff48",
  null
  
)

export default component.exports